function initHomeDefaultSliders() {
  const sliders = document.querySelectorAll('.js-home-default-slider');

  sliders.forEach((sliderEl, index) => {
    const className = `js-home-default-slider-${index + 1}`;

    if (!sliderEl.classList.contains(className)) {
      sliderEl.classList.add(className);
    }

    if (sliderEl.splideInstance) {
      sliderEl.splideInstance.destroy();
      sliderEl.classList.remove('splide-initialized');
    }

    const slidesCount = sliderEl.querySelectorAll('.splide__slide').length;

    const splide = new Splide(`.${className}`, {
      type: 'fade',
      rewind: true,
      speed: 300,
      perPage: 1,
      pagination: slidesCount > 1, 
      arrows: false,
    });

    splide.mount();

    sliderEl.classList.add('splide-initialized');
    sliderEl.splideInstance = splide;
  });

  setTimeout(() => {
    document.querySelectorAll('.js-slider-item-content').forEach(el => {
      el.classList.add('active');
    });
  }, 100);
}

document.addEventListener('DOMContentLoaded', initHomeDefaultSliders);

if (window.Shopify && Shopify.designMode) {
  ['shopify:section:load','shopify:section:select','shopify:block:select','shopify:block:deselect']
    .forEach(eventName => {
      document.addEventListener(eventName, () => {
        initHomeDefaultSliders();
      });
    });

  document.addEventListener('shopify:block:select', function(e){
    const sectionId = e.detail?.sectionId;
    const blockId   = e.detail?.blockId;

    const sectionEl = document.querySelector(`#shopify-section-${sectionId}`);
    if(!sectionEl) return;

    const sliderEl = sectionEl.querySelector('.js-home-default-slider');
    if(!sliderEl?.splideInstance) return;

    const slideEl = sliderEl.querySelector(`[data-block-id="${blockId}"]`).closest('.splide__slide');
    if(!slideEl) return;

    const slides = Array.from(sliderEl.querySelectorAll('.splide__slide'));
    const index  = slides.indexOf(slideEl);

    if(index >= 0){
      sliderEl.splideInstance.go(index);
    }
  });
}